export default [
  {
    path: "share-products",
    name: "share-products",
    component: () => import("./index"),
    meta: {
      sort: -1,
      visible: true,
      label: "menu.lading_page",
      icon: "thumb_up",
      breadcrumb: {
        title: "Compartilhar produtos",
        icon: "share",
        name: "share-products",
        path: "/share-products"
      }
    },
  },
];
